import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function CustomSelect({
  filterValue,
  setFilterValue,
  title,
  options,
  setpagination,
}) {
  const handleChange = (event) => {
    setpagination && setpagination(event.target.value);
    setFilterValue(event.target.value);
  };

  return (
    <FormControl fullWidth size="larg">
      <InputLabel id="demo-select-small-label">{title}</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={filterValue}
        label={title}
        onChange={handleChange}
      >
        {options?.map((menu, index) => {
          return (
            <MenuItem key={index + menu.label} value={menu.value}>
              {menu.key || menu.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
